var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouseStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 47,
    viewBox: "0 0 66 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1338 45.9183C28.1338 45.9183 41.2071 44.0507 50.8119 36.5802C60.4168 29.3766 75.6245 14.9694 56.148 16.0366C36.6714 17.1038 32.1358 17.6374 32.1358 17.6374L28.1338 45.9183Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.118579 23.24C-0.148223 25.908 0.118579 32.845 0.118579 34.4459C0.118579 36.0467 2.78673 38.7144 8.92317 42.1828C15.0596 45.6513 23.8643 46.9855 30.5344 45.3847C37.2044 43.7839 47.3424 38.181 54.0124 32.3113C60.6824 26.4417 63.6175 22.9733 63.6175 21.6392C63.8843 20.3052 58.8151 14.1687 58.2815 12.5679C58.0147 10.9671 53.4791 2.69632 50.2774 1.62911C37.471 -2.90652 1.71939 9.3663 0.118579 23.24Z",
    fill: "#24243F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3989 46.1851C26.5333 46.1851 28.6679 45.9185 30.5355 45.3849C37.4723 43.7841 47.3435 38.1812 54.0135 32.3116C60.6835 26.4419 63.6186 22.9735 63.6186 21.6395C63.8854 20.3055 63.8854 14.169 63.6186 12.3014C63.6186 11.7678 62.2844 9.09994 60.6835 7.76593C57.4819 5.36471 52.4127 2.16303 50.0115 1.36262C44.1418 -0.771792 34.0035 1.03158 24.1318 4.5V46.1851H24.3989Z",
    fill: "#141426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8147 6.69814C55.8799 4.56373 52.1448 2.42918 50.2772 1.89558C39.0715 -2.10645 11.0576 6.43121 2.51994 17.9037C0.919126 23.7733 1.9862 29.1094 7.05544 32.5778C17.9943 40.315 25.4649 39.248 37.2042 33.1116C43.8742 29.6432 59.3482 18.1706 62.0162 14.7022C64.6842 11.2338 58.8147 6.69814 58.8147 6.69814Z",
    fill: "url(#paint0_linear_2_31172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31172",
    x1: 25.5004,
    y1: 4.13112,
    x2: 31.5073,
    y2: 17.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40495D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2E47"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseStandard);
export default __webpack_public_path__ + "static/media/MouseStandard.9e7a5f096ecd5aa973cb078d429c73c5.svg";
export { ForwardRef as ReactComponent };